import React, { useContext, useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, Stack, Tooltip } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import UserDetailsContext, { useUserDetails } from "../../context/auth";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from "react-router-dom";
import "./perfomance.css";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import MaterialSelect from "../../components/MasterSelect";
import Swal from "sweetalert2";
import axios from "axios";
const performanceByUser = gql`
  query GetPerformanceByUser($userId: String!) {
    performanceByUser(id: $userId) {
      id

      user {
        id
        firstName
        lastName
        department
        designation
        dateJoined
        employeeType
        probationPeriod
      }

      teamleaderId

      reviewNumber

      duration

      comments

      onTimeWorkDelivery

      professionalBehavior

      assignmentPerformance

      communicationSkills

      teamworkAbility

      multitaskingAbility

      decisionMaking

      attitude

      technicalSkills

      totalScore
      evaluatedBy
      date
    }
  }
`;

const allPerformanceEvaluations = gql`
  query {
    allPerformanceEvaluations {
      id

      user {
        id
        firstName
        lastName
        department
        designation
        dateJoined
        employeeType
        probationPeriod
      }

      teamleaderId

      reviewNumber

      duration

      comments

      onTimeWorkDelivery

      professionalBehavior

      assignmentPerformance

      communicationSkills

      teamworkAbility

      multitaskingAbility

      decisionMaking

      attitude

      technicalSkills

      totalScore

      date
      evaluatedBy
    }
  }
`;
const performancesByTeamLeader = gql`
  query GetPerformanceByTeamLeader($teamLeaderId: String!) {
    performancesByTeamLeader(teamLeaderId: $teamLeaderId) {
      id

      user {
        id
        firstName
        lastName
        department
        designation
        dateJoined
        employeeType
        probationPeriod
      }

      reviewNumber

      duration

      comments

      onTimeWorkDelivery

      professionalBehavior

      assignmentPerformance

      communicationSkills

      teamworkAbility

      multitaskingAbility

      decisionMaking
      evaluatedBy
      attitude

      technicalSkills

      totalScore

      date
    }
  }
`;

const deletePerformanceEvaluation = gql`
  mutation DeletePerformanceEvaluation($id: ID!) {
    deletePerformanceEvaluation(id: $id) {
      success
    }
  }
`;

const PerformanceEvaluation = () => {
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [perfomaceList, setPerfomaceList] = useState([]);
  const navigate = useNavigate();

  const { user, AccessData } = useUserDetails();
  console.log("issss",user);
  
  const role = user?.role;
  console.log("roleeeee",role);
  
  const [selectHr, setSelectHr] = useState(
    role.toLowerCase() === "hrmanager"
      ? { value: "All", label: "All" }
      : { value: "Team", label: "Team" }
  );

  const [TeamLeaderID, setTeamLeaderID] = useState([]);

  const getteamleadeID = async () => {
    const query = `  
   query{
  allManagers{
    id
    status
    lastupdate
    user{
      id
      empid
      department
      firstName
      lastName
      
    }
  }
}
`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responsedddddddd:", user, response.data);

      const managerList = response.data.data.allManagers;
      const filterdata = managerList.filter(
        (val) => val.user.empid == user.empid
      );
      let dataid = filterdata[0]?.user?.id;
      localStorage.setItem("reqteam", dataid);
      setTeamLeaderID(filterdata);
      console.log("filterdatafilterdata:", filterdata);

      // setManagerList(managerList);
      // setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response:", managerList);
    } catch (error) {
      console.error("ResponseError:", error);
      // setPageState({
      //   ...pageState,
      //   loading: false,
      //   error: true,
      //   message: error.message,
      // });
    }
  };

  useEffect(() => {
    getteamleadeID();
  }, []);

  useEffect(() => {
    fetchData();
  }, [TeamLeaderID]);

  const fetchData = () => {
    let reportnum = localStorage.getItem("reqteam");
    let idata = user?.id;
    const encodedId = btoa(idata);
    if (role?.toLowerCase() == "hrmanager") {
      request(BASEURL, allPerformanceEvaluations).then((res) =>
        setPerfomaceList(res?.allPerformanceEvaluations)
      );
    } else if (role?.toLowerCase() == "employee") {
      request(BASEURL, performanceByUser, {
        userId: idata,
      }).then((res) => setPerfomaceList(res?.performanceByUser));
    } else if (role?.toLowerCase() == "intern") {
      request(BASEURL, performanceByUser, {
        userId: idata,
      }).then((res) => setPerfomaceList(res?.performanceByUser));
    } else if (role?.toLowerCase() == "manager") {
      console.log("isuser",user?.teamleader);
      
      request(BASEURL, performancesByTeamLeader, {
        teamLeaderId: String(user?.teamleader),
      }).then((res) => handleData(res?.performancesByTeamLeader));
    }
  };

  const handleData = (data) => {
    console.log("datadatadata:", data);

    let filteredData = data.filter(
      (val) => val?.user?.id === TeamLeaderID[0]?.user?.id
    );

    console.log("filteredData:", filteredData);

    if (filteredData.length >= 0) {
      request(BASEURL, performancesByTeamLeader, {
        teamLeaderId: filteredData[0]?.user?.id
          ? filteredData[0]?.user?.id
          : TeamLeaderID[0]?.user?.id,
      })
        .then((res) => {
          let resultdata = res?.performancesByTeamLeader;
          let mergedData = [...filteredData, ...resultdata];
         console.log('mergedData;',mergedData);
         
          setPerfomaceList(mergedData);
        })
        .catch((error) => {
          console.error("API Request Failed:", error);
        });
    } else {
      console.warn("No matching data found for the given Team Leader ID.");
    }
  };

  const selecthrOption1 = ["All", "Team"];
  const selecthrOption2 = ["My List", "Team"];

  const handleDelte = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Delete Your Details",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = request(BASEURL, deletePerformanceEvaluation, { id: id });
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Deleted Successfully",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            fetchData();
          });
        } catch (err) {
          console.error(err.message);
        }
      }
    });
  };

  const managers = user?.role?.toLowerCase();

  const perfomaceListTable = {
    columns: [
      {
        field: "sno",
        headerName: "S.No.",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "name",
        headerName: "First Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "lastname",
        headerName: "Last Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "date",
        headerName: "Date",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "totalScore",
        headerName: "Total Score",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "review",
        headerName: "Review Number",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "duration",
        headerName: "Duration",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Action",
        field: "action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: (perfomaceList || [])
      ?.slice()
      .reverse()
      .map((v, i) => ({
        id: v.id,
        sno: i + 1,

        name: v?.user?.firstName,
        lastname: v?.user?.lastName,
        review: v.reviewNumber,
        duration: v?.duration,
        totalScore: v?.totalScore,
        date: v?.date,
        action: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
          >
            {(managers == "manager" || managers == "hrmanager") && (
              <Tooltip title="Edit">
                {role?.toLowerCase() == "hrmanager" &&
                  selectHr?.label == "Team" && (
                    <EditIcon
                      onClick={() =>
                        navigate(
                          "/performance-evaluation/performance-evaluation-details",
                          {
                            state: { id: v?.id, name: v },
                          }
                        )
                      }
                      style={{ margin: "0px 5px", cursor: "pointer" }}
                    />
                  )}
                {role?.toLowerCase() == "manager" && (
                  <EditIcon
                    onClick={() =>
                      navigate(
                        "/performance-evaluation/performance-evaluation-details",
                        {
                          state: { id: v?.id, name: v },
                        }
                      )
                    }
                    style={{ margin: "0px 5px", cursor: "pointer" }}
                  />
                )}
              </Tooltip>
            )}
            {/* {(managers == "manager" || managers == "hrmanager") && (
            <Tooltip title="Delete">
              {role?.toLowerCase() == "hrmanager" &&
                selectHr?.label == "Team" && (
                  <DeleteIcon
                    onClick={() => handleDelte(v?.id)}
                    style={{ margin: "0px 5px", cursor: "pointer" }}
                  />
                )}
              {role?.toLowerCase() == "manager" && (
                <DeleteIcon
                  onClick={() => handleDelte(v?.id)}
                  style={{ margin: "0px 5px", cursor: "pointer" }}
                />
              )}
            </Tooltip>
          )} */}

            <Tooltip title="View">
              <RemoveRedEyeIcon
                onClick={() =>
                  navigate(
                    `/performance-evaluation/performance-evaluation-details`,
                    {
                      state: {
                        id: v?.id,
                        name: v,
                        status: "view",
                        disbled: true,
                      },
                    }
                  )
                }
                style={{ margin: "0px 5px", cursor: "pointer" }}
              />
            </Tooltip>
          </div>
        ),
      })),
  };

  const handleNewEvaluation = () => {
    navigate(`/performance-evaluation/performance-evaluation-details`);
  };

  const handleSelectHrChange = (e) => {
    let reportnum = localStorage.getItem("reqteam");
    if (e?.value == "All") {
      request(BASEURL, allPerformanceEvaluations).then((res) =>
        setPerfomaceList(res?.allPerformanceEvaluations)
      );
    } else if (e?.value == "Team") {
      request(BASEURL, performancesByTeamLeader, {
        teamLeaderId: TeamLeaderID[0]?.user?.id,
      }).then((res) => setPerfomaceList(res?.performancesByTeamLeader));
    }
    setSelectHr(e);
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Performance Evaluation List
                </MaterialTypography>
              </Stack>

              {role?.toLowerCase() === "hrmanager" &&
                role?.toLowerCase() !== "manager" && (
                  <MaterialSelect
                    name="selecthr"
                    value={selectHr}
                    onChange={(e) => handleSelectHrChange(e)}
                    options={selecthrOption1?.map((value) => ({
                      value: value,
                      label: value,
                    }))}
                  />
                )}
              {/* { role?.toLowerCase() == "manager" && (
  <MaterialSelect
    name="selecthr"
    value={selectHr}
    onChange={(e) => handleSelectHrChange(e)}
    options={selecthrOption2?.map((value) => ({
      value: value,
      label: value,
    }))}
  />
)} */}

              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddPerformance" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewEvaluation()}
                  >
                    Add Evaluation
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={perfomaceListTable.rows}
          customHeight={550}
          columns={perfomaceListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Performance Evaluation data found
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default PerformanceEvaluation;
